export class LatLng {
    lat: number;
    lng: number;
}